import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import {articleList,articleDetail} from '@/api/server/article'
export default {
  name: 'articlePage',
  mixins: [commonMixin],
  data () {
    return {
      list: null,
      info: {
        title: null,
        content: null
      },
      id: null
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent
  },
  methods: {
    onDetail (item) {
      this.info = item
    },
    _getDetail () {
      let query = {
        id: this.id
      }
      articleDetail(query).then( (res) => {
        if (res.code === 200 && res.data) {
          this.info = res.data
        }
      })
    },
    _getList () {
      articleList().then( (res)=> {
        if (res.code === 200 && res.data) {
          this.list = res.data
        }
      })
    },
    reset () {
      this.list = null
      this._getList()
      this._getDetail()
    },
    handleRoute (route) {
      if (route.name === 'article') {
        this.id = this.$route.query.id
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}